<!-- @format -->

<div class="selected float-end">
  <span
    translate="PLAN_EDIT.SELECTION_ASSISTANT.RULE_HEADER.CREDIT_STATUS"
    [translateParams]="{ from: plannedCredits.min, to: targetCredits | translateRange }">
  </span>
</div>
@if (!isOk) {
  <div class="badge">
    <sis-icon icon="rule" color="white"></sis-icon>
    @if (notEnoughCreditsSelected) {
      <span translate="PLAN_EDIT.SELECTION_ASSISTANT.RULE_HEADER.CREDITS_TO_ADD" [translateParams]="{ range: addRange | translateRange }">
      </span>
    }
    @if (tooManyCreditsSelected) {
      <span
        translate="PLAN_EDIT.SELECTION_ASSISTANT.RULE_HEADER.CREDITS_TO_REMOVE"
        [translateParams]="{ range: removeRange | translateRange }">
      </span>
    }
  </div>
}
